export const PATHS = {
  byLocationName: ({ units, locationQuery }) =>
    `https://api.openweathermap.org/data/2.5/weather?q=${locationQuery}&appid=91b1dc1ee1d16d9ec4300559a27c844a&units=${units}`,
  byZipCode: ({ units, locationQuery }) =>
    `https://api.openweathermap.org/data/2.5/weather?zip=${locationQuery}&appid=91b1dc1ee1d16d9ec4300559a27c844a&units=${units}`,
};

export default PATHS;